<script>
  export let aspect
  export let bilder

  function getColor(a, b) {
    if (a === 'vertikal-enkel') {
      return b.vertikal?.averageColor?.hex
    } else if (a === 'vertikal-dobbel' || a === 'horisontal') {
      return b.horisontal?.averageColor?.hex
    }
    return '#fff'
  }

  function getSrcSet(a, b) {
    let image = []
    switch (a) {
      case 'vertikal-enkel':
        image = b.vertikal.crops
        break
      case 'vertikal-dobbel':
        image = b.horisontal.crops.filter((el) => el.format === '16:9')
        break
      case 'horisontal':
        image = b.horisontal.crops.filter((el) => el.format === '3:2')
    }
    return image.map((crops) => `${crops.url} ${crops.width}w`).join(', ')
  }

  function getImage(a, b) {
    let image = []
    switch (a) {
      case 'vertikal-enkel':
        image = b.vertikal.crops
        break
      case 'vertikal-dobbel':
        image = b.horisontal.crops.filter((el) => el.format === '16:9')
        break
      case 'horisontal':
        image = b.horisontal.crops.filter((el) => el.format === '3:2')
    }
    return image[0].url
  }
</script>

<style>
  img {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    height: 100%;
    width: 100%;
    border-radius: 6px 6px 0 0;
  }

  .horisontal {
    border-radius: 6px 0 30px 6px;
  }

  .aspect {
    overflow: hidden;
    position: relative;
    width: 100%;
    border-radius: 6px 6px 0 0;
  }
  .aspectBig {
    padding-top: calc((9 / 16) * 100%);
  }
  .aspectMedium {
    padding-top: calc((3.5 / 3) * 100%);
  }
  .aspectSmall {
    padding-top: calc((2 / 3) * 100%);
    border-radius: 6px 0 30px 6px;
  }
</style>

<div
  style="background: {getColor(aspect, bilder)}"
  class="aspect"
  class:aspectBig={aspect === 'vertikal-dobbel'}
  class:aspectMedium={aspect === 'vertikal-enkel'}
  class:aspectSmall={aspect === 'horisontal'}>
  {#if bilder}
    <img
      class:horisontal={aspect === 'horisontal'}
      srcSet={getSrcSet(aspect, bilder)}
      src={getImage(aspect, bilder)}
      alt="" />
  {/if}
</div>
